<template>
	<div class="new-folder">
        <input type="text" placeholder="Name" v-model="current_name" class="form-control">
        <button class="btn btn-sm btn-primary" @click="EditName" :disabled="current_name == ''">Save</button>
	</div>
</template>

<script>
	export default {
		props: { fileId: Number, name: String },

		data(){
            return {
                current_name: ''
            }
        },

        mounted(){
            this.current_name = this.name;
        },

        methods: {
            EditName(){
                this.$store.dispatch('editFile', {
                    file_id: this.fileId,
                    name: this.current_name
                });

                this.$parent.closeModal();
            }
        },

        watch: {
            name(){
                this.current_name = this.name;
            }
        }
	}
</script>
